<template>
    <div class="google-map-street-view-loader">
        <div
                ref="googleMap"
                class="google-street-view-map"
        />
    </div>
</template>

<script>
    import './GoogleMapStreetViewLoader.scss';
    import GoogleMapsLoader from "../../../classes/GoogleMapsLoader";

    export default {
        name: 'GoogleMapStreetViewLoader',
        props: {
            mapConfig: {
                type: Object,
                required: true,
            },
            marker: {
                type: Object,
                required: true,
            },
        },

        beforeMount() {
            this.initializeMap();
        },

        methods: {
            async initializeMap() {
                let googleMapsLoader = GoogleMapsLoader.instance();
                googleMapsLoader.load();
                await googleMapsLoader.importLibrary('maps');

                let map = new googleMapsLoader.google.maps.Map(this.$refs.googleMap, {
                    ...this.mapConfig,
                    center: {
                        lat: this.marker.latLng.lat,
                        lng: this.marker.latLng.lng,
                    },
                    streetView: new googleMapsLoader.google.maps.StreetViewPanorama(this.$refs.googleMap, {
                        position: {
                            lat: this.marker.latLng.lat,
                            lng: this.marker.latLng.lng,
                        },
                        panControlOptions: {
                            position: googleMapsLoader.google.maps.ControlPosition.BOTTOM_RIGHT
                        },
                        fullscreenControl: false,
                        addressControl: false,
                        enableCloseButton: false,
                        zoomControlOptions: {
                            position: googleMapsLoader.google.maps.ControlPosition.BOTTOM_RIGHT
                        }
                    })
                });
            },
        }
    };
</script>
